<template>
    <div v-if="state.connectionLost" class="draft-connection-notice" role="status" aria-live="polite">
        <div><strong>Нет связи с сервером</strong><span>Можно продолжать ввод. Проверяем связь автоматически; действия на сервере станут доступны после подключения.</span></div>
        <b-button size="sm" variant="outline-primary" :disabled="state.checking" @click="$store.dispatch('appVersion/checkNow')">
            <span class="draft-connection-indicator" aria-hidden="true"><b-spinner v-if="state.checking" small /></span>Проверить связь
        </b-button>
    </div>
</template>
<script>
export default {name: 'DraftConnectionNotice', computed: {state() { return this.$store.state.appVersion; }}};
</script>
<style scoped>
.draft-connection-notice { width: 100%; display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 8px; padding: 9px 11px; border: 1px solid #e5d4b7; border-radius: 9px; background: #fff9ef; color: #77501c; }
.draft-connection-notice > div { flex: 1 1 220px; }
.draft-connection-notice strong, .draft-connection-notice span:not(.draft-connection-indicator) { display: block; font-size: .85rem; }
.draft-connection-notice button { flex: none; white-space: nowrap; }
.draft-connection-indicator { display: inline-block; width: 1rem; height: 1rem; margin-right: 5px; vertical-align: middle; }
.draft-connection-indicator .spinner-border { width: 1rem !important; height: 1rem !important; border-width: 2px; }
</style>
